module.exports = __webpack_public_path__ + "files/b427b10a43c5c0b4408b7a89ddaffc38.png";